import { render, staticRenderFns } from "./EntityObjectInfo.vue?vue&type=template&id=37e7c41a&scoped=true"
import script from "./EntityObjectInfo.vue?vue&type=script&lang=js"
export * from "./EntityObjectInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e7c41a",
  null
  
)

export default component.exports